module.exports = __webpack_public_path__ + "static/img/GP.91e57fbb.svg";